import { ErrorContent } from "@/components/commons/fallback/ErrorContent";
import { isChunkLoadError } from "@/utils/chunk";
import { useTranslation } from "react-i18next";
import { useRouteError } from "react-router-dom";

const handleReload = () => {
  window.location.reload();
};
/**
 * Route-level error fallback used as `errorElement` in react-router.
 * Shows a friendly reload page for chunk load failures (network/timeout),
 * and a generic error page for other unexpected errors.
 */
const RouteErrorFallback = () => {
  const error = useRouteError();
  const { t } = useTranslation();
  const isChunk = isChunkLoadError(error);

  return (
    <ErrorContent
      title={isChunk ? t("common.chunkError.title") : t("common.errorFallback.title")}
      message={isChunk ? t("common.chunkError.message") : t("common.errorFallback.message")}
      buttonLabel={isChunk ? t("common.chunkError.reload") : t("common.errorFallback.reload")}
      onAction={handleReload}
    />
  );
};

export default RouteErrorFallback;
